// While an area scrolls, its scroll bar shows (Fixes 8, David: "It shows while scrolling or on hover, then fades out,
// as on a Mac"). The style is in base.css: the bar is clear at rest, and shows under the pointer and on an element
// marked data-scrolling, which this puts on whatever scrolls and takes off a moment after it stops. One listener for
// the page, on the way down, since a scroll does not bubble; nothing is kept but the timers.

const QUIET_MS = 800;
const timers = new WeakMap<Element, number>();

export function watchScrolling(doc: Document = document) {
  doc.addEventListener(
    "scroll",
    (e) => {
      const el = e.target === doc ? doc.scrollingElement : e.target;
      if (!(el instanceof Element)) return;
      if (!el.hasAttribute("data-scrolling")) el.setAttribute("data-scrolling", "");
      const was = timers.get(el);
      if (was) clearTimeout(was);
      timers.set(
        el,
        window.setTimeout(() => {
          timers.delete(el);
          el.removeAttribute("data-scrolling");
        }, QUIET_MS),
      );
    },
    { capture: true, passive: true },
  );
}
